import * as React from "react";

export const SpeedBumpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="300.000000pt"
    height="267.000000pt"
    viewBox="0 0 300.000000 267.000000"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <g transform="translate(0.000000,267.000000) scale(0.100000,-0.100000)" fill="#ffffff" stroke="none">
      <path
        d="M1430 2627 c-62 -20 -110 -85 -269 -363 -85 -148 -237 -411 -337
-584 -561 -970 -772 -1339 -787 -1378 -39 -97 -8 -195 77 -247 l49 -30 1311
-3 c956 -2 1322 0 1352 9 53 14 112 63 130 105 22 52 17 131 -10 189 -13 28
-175 313 -361 635 -185 322 -448 776 -582 1010 -325 563 -338 583 -378 619
-54 47 -123 61 -195 38z m111 -38 c56 -19 96 -66 181 -214 294 -508 385 -666
555 -960 105 -181 284 -492 398 -690 114 -198 219 -382 231 -410 48 -101 23
-188 -66 -232 l-44 -23 -1301 0 -1301 0 -44 23 c-66 33 -93 78 -88 148 4 49
15 76 93 210 49 85 164 285 256 444 678 1179 944 1634 968 1658 25 25 87 55
117 57 6 0 26 -5 45 -11z"
      />
      <path
        d="M1437 2478 c-22 -25 -1108 -1895 -1258 -2166 -39 -71 -38 -112 2
-146 l31 -26 1279 0 c1390 0 1318 -3 1349 54 12 24 11 32 -6 74 -37 86 -1247
2176 -1280 2210 -21 20 -42 32 -59 32 -19 0 -38 -11 -58 -32z m90 -20 c11 -13
75 -120 143 -238 68 -118 153 -267 190 -330 37 -63 119 -205 182 -315 63 -110
218 -378 343 -595 405 -701 425 -737 425 -758 0 -12 -9 -26 -19 -32 -27 -14
-2565 -14 -2592 0 -29 16 -24 38 30 130 55 96 210 367 521 905 377 655 424
736 564 980 125 217 164 275 185 275 4 0 17 -10 28 -22z"
      />
      <path
        d="M1344 786 c-40 -8 -89 -19 -110 -26 -72 -23 -188 -90 -264 -151 -130
-105 -126 -104 -348 -107 l-192 -4 0 -71 0 -72 1067 2 1068 3 3 69 3 69 -198
4 c-228 3 -222 1 -363 118 -85 70 -181 119 -290 150 -97 27 -277 35 -376 16z
m360 -55 c110 -29 188 -69 292 -151 140 -110 152 -115 329 -118 183 -3 197 -5
193 -35 l-3 -22 -1020 0 c-990 0 -1020 1 -1023 19 -2 10 2 22 10 27 7 5 78 9
158 9 80 0 162 5 183 11 36 10 85 41 219 142 173 131 433 177 662 118z"
      />
    </g>
  </svg>
);
